import { Routes, Route, Navigate } from 'react-router-dom';
import PlaceDetails from '@/Pages/Places/Details/PlaceDetails';

import PlaceForm from '@/Pages/Places/Register/PlaceForm';
import PlaceList from '@/Pages/Places/List/PlacesList';
import PlaceFaresFormContainer from '@/Pages/fares/place-fares-form-container/PlaceFaresFormContainer';

function Places() {
  return (
    <Routes>
      <Route path="/" element={<PlaceList />} />

      <Route path=":placeId/editar" element={<PlaceForm />} />

      <Route path=":placeId/tarifa" element={<PlaceFaresFormContainer />} />

      <Route path=":placeId" element={<PlaceDetails />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default Places;
